// src/pages/PathManagePatient/BilledTests.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import { getBilledTests } from "../../services/pathLabTestReportService";
import Refresh from "@mui/icons-material/Refresh"; // Import refresh icon
import CollectSampleModal from "./CollectSampleModal"; // Import the CollectSampleModal
import UpdateLabTestResultModal from "./UpdateLabTestResultModal"; // Import the UpdateLabTestResultModal
import Calendar from "../calendar/calendar"; // Import the Calendar component

const BilledTests = () => {
  const [billedTests, setBilledTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCollectSampleModal, setOpenCollectSampleModal] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [openUpdateResultModal, setOpenUpdateResultModal] = useState(false);
  const [openCalendar, setOpenCalendar] = useState(false); // State for Calendar
  const [labTestInfo, setLabTestInfo] = useState({}); // State for lab test info

  useEffect(() => {
    fetchBilledTests();
  }, []);

  const fetchBilledTests = async () => {
    try {
      const data = await getBilledTests(); // Fetch billed tests from the service
      // setBilledTests(data);
      const sorted = [...(data || [])].sort((a, b) => new Date(b.reportDate) - new Date(a.reportDate));
      setBilledTests(sorted);
    } catch (error) {
      console.error("Error fetching billed tests:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCollectSample = (test) => {
    // console.log("Selected Test:", test); // Log the selected test
    setSelectedTest(test); // Set the selected test
    setOpenCollectSampleModal(true); // Open the modal
  };

  const handleResultAwaited = () => {
    setOpenUpdateResultModal(true); // Open the result update modal
  };

  const handleViewDetails = (test) => {
    setLabTestInfo({
      patientId: test.patientId,
      patientName: test.patientName,
      doctorId: test.doctorId,
      doctorName: test.doctorName,
    });
    setOpenCalendar(true); // Open the Calendar
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Billed Tests</Typography>
          <IconButton onClick={fetchBilledTests}>
            <Refresh />
          </IconButton>
        </Grid>
        {billedTests.length > 0 ? (
          billedTests.map((test) => (
            <Grid item xs={12} sm={6} md={4} key={test.reportId}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body1">Patient: {test.patientName}</Typography>
                <Typography variant="body1">Doctor: {test.doctorName}</Typography> {/* Display Doctor's Name */}
                <Typography variant="body2">Test Name: {test.testName}</Typography>
                {/* <Typography variant="body2">Amount: {test.amount}</Typography> */}
                {/* <Typography variant="body2">Report ID: {test.reportId}</Typography> */}
                <Typography variant="body2">Report Date: {new Date(test.reportDate).toLocaleDateString()}</Typography>
                <Box display="flex" justifyContent="space-between" marginTop={1}>
                  <Button variant="contained" color="primary" onClick={() => handleViewDetails(test)}>View Details</Button>
                  <Button 
                    variant="outlined" color="secondary" 
                    onClick={() => handleCollectSample(test)} // Handle collect sample
                  >
                    Collect Sample
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography>No billed tests available.</Typography>
          </Grid>
        )}
      </Grid>
      {/* Collect Sample Modal */}
      <CollectSampleModal
        open={openCollectSampleModal}
        onClose={() => setOpenCollectSampleModal(false)}
        test={selectedTest}
        onSampleCollected={fetchBilledTests} // Refresh the list after sample collection
        onResultAwaited={handleResultAwaited} // Pass the result awaited handler
      />

      {/* Update Lab Test Result Modal */}
      <UpdateLabTestResultModal
        open={openUpdateResultModal}
        onClose={() => setOpenUpdateResultModal(false)}
        reportId={selectedTest?.reportId} // Pass the reportId to the modal
        test={selectedTest} // Pass the test object here
        refetchPathLabTestList={fetchBilledTests} // Pass the refetch function
      />

      {/* Calendar Component */}
      <Calendar
        open={openCalendar}
        onClose={() => {
          setOpenCalendar(false);
          setLabTestInfo(null);
        }}
        appointment={labTestInfo} // Pass the lab test info to the Calendar
      />

    </Box>
  );
};

export default BilledTests;
